import { isApple } from './isApple'

export const isControl = event => {
  if (isApple()) {
    return event.metaKey // Apple
  }
  return event.ctrlKey // Windows, Linux, UNIX
}
